import { ActionMenu } from '@monorepo/shared/componentsV2/menus/ActionMenu';
import { ViewType } from 'mapistry-shared';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useCopyViewModal } from '../../hooks/useCopyViewModal';
import { useEditViewInfoModal } from '../../hooks/useEditViewInfoModal';
import { useViewDeleteWithConfirm } from '../../hooks/useViewDelete';

interface ViewsTableActionsProps {
  viewId: string;
  viewOriginId: string;
  viewName: string;
  viewType: ViewType;
}

export function ViewsTableActions({
  viewId,
  viewOriginId,
  viewName,
  viewType,
}: ViewsTableActionsProps) {
  const { organizationId, projectId } = useParams();
  const { openModal: openEditViewInfoModal } = useEditViewInfoModal();
  const { openModal: openCopyViewModal } = useCopyViewModal();
  const handleDelete = useViewDeleteWithConfirm({
    organizationId,
    projectId,
    viewId,
    viewName,
  });

  const handleEditDetails = useCallback(
    () =>
      openEditViewInfoModal({ existingViewId: viewId, viewOriginId, viewType }),
    [openEditViewInfoModal, viewOriginId, viewId, viewType],
  );

  const handleCopy = useCallback(
    () => openCopyViewModal({ existingViewId: viewId }),
    [openCopyViewModal, viewId],
  );

  return (
    <ActionMenu
      altText={`Action menu for ${viewName} Report`}
      options={[
        { displayName: 'Edit details', onClick: handleEditDetails },
        { displayName: 'Copy', onClick: handleCopy },
        { displayName: 'Delete', onClick: handleDelete },
      ]}
    />
  );
}
